import { carouselItems } from '@/mocks/homeData';

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            焦点推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选热门专题与深度内容，每期聚焦不同主题，带你发现漫画世界的更多精彩
          </p>
        </div>

        <div className="flex flex-col gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group flex flex-col lg:flex-row rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors duration-200"
            >
              <div className="relative w-full lg:w-[420px] aspect-[2/1] lg:aspect-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <span className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-background-50/90 text-sm font-medium text-foreground-800 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-7 flex-1 flex flex-col justify-center gap-3">
                <span className="text-xs font-medium text-primary-600 uppercase tracking-wide">
                  {item.category}
                </span>
                <h3 className="text-lg md:text-xl font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}